import Vue from "vue";
import i18n from "@/i18ns/i18n";
import { MSEnum } from "@/commons/enumeration";
import store from "@/stores/store";
import { ModuleContext } from "@/stores/moduleConst";
import _ from "lodash";
import moment from "moment";
import messageBox from '@/commons/messageBox';
import proxyApi from "@/apis/bussiness/proxyAPI";
import router from '@/routers/router'
import countryNameJson from "@/assets/country.name.json";
import DOMPurify from "dompurify";
import { marked } from "marked";

/**
 * Class chứa các function dùng chung cho hệ thống phía client
 */
class CommonFunction {
  getMainLoading() {
    let el = document.body.querySelector("#mloading");
    return el;
  }
  mask() {
    let el = this.getMainLoading();
    if (el) {
      el.style.display = "flex";
    }
  }
  unmask() {
    let el = this.getMainLoading();
    if (el) {
      el.style.display = "none";
    }
  }
  infoLogging() { }
  errorLogging() { }
  handleException(error, showAlert) {
    console.error(error);

    if (showAlert) {
      const msgBox = messageBox,
        localize = i18n;
      msgBox.showError(
        localize.t("i18nCommon.GlobalErrorMessage")
      );
    }
  }

  /**
     * Xử lý hiển thị dialog
     * @author DNThang - 30.10.2019
   * DNThang - 06.05.2020: Trong trường hợp owner là popup thì sẽ append vào content để không bị chìm ở dưới
     */
  prepareForDialog(component, owner, options) {
    var me = this;
    if (owner && component) {
      var frmType = Vue.extend(component), frm = new frmType(options);

      frm.$mount();

      if (owner.isMsPopup) {
        let contentElement = owner.$refs.popupx;//owner.$el.querySelector('.ms-popup-content.ms-popup');
        contentElement.appendChild(frm.$el);
      } else {
        if (owner instanceof Element) {
          owner.appendChild(frm.$el);
        } else {
          owner.$el.appendChild(frm.$el);
        }
      }

      return frm;
    }

    return;
  }
  /**
   * Build vue key cho data
   */
  genVKeyValue(data, field = "__vKeyValue") {
    if (data) {
      data.forEach(item => {
        item[field] = this.generateUUID();
      });
    }
  }
  /**
   *  Tạo uuid
   *  Create by: pvduong1 - 30/08/2019
   */
  generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      let d = new Date().getTime();
      d += performance.now();
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  /**
   * Guild empty
   */
  generateEmptyUUID() {
    return "00000000-0000-0000-0000-000000000000";
  }
  /**
   * Kiểm tra 2 đối tượng có phải là cha con của nhau không
   */
  hasParent(child, parent) {
    if (child.parentElement) {
      if (child.parentElement === parent) {
        return true;
      } else {
        return this.hasParent(child.parentElement, parent);
      }
    }

    return false;
  }

  /**
  * Kiểm tra đối tượng có class style không
  * Modified nntam: thêm case cối vào cho không chết
  */
  hasClass(element, className) {
    if (element && element.className) {
      return element.className.indexOf(className) > -1;
    }
    return false;
  }

  shortkeyPushView(el) {
    window.shortkeyView.remove(el);
    window.shortkeyView.push(el);
  }

  shortkeyPopView(el) {
    window.shortkeyView.remove(el);
  }

  /**
   * Xử lý render element động
   * modified by ntphong 28/5/2021 - isAppendTarget: nếu là append 1 đoạn code html vào 1 trong target
   */
  renderDynamicElement(target, component, owner, options, isAppendTarget) {
    var me = this;
    if (component) {
      var frmType = Vue.extend(component),
        frm = new frmType(options);

      frm.$mount();

      if (target && isAppendTarget && frm.$el) {
        target.appendChild(frm.$el);
      }
      return frm;
    }
  }

  /**
   * focus vào control tiếp theo
   */
  focusNextControl(curfocus) {
    var el = this.getNextInputControl(curfocus);
    if (el) {
      el.focus();
      if (typeof el.select === "function") {
        el.select();
      }

      return true;
    }
  }

  /**
   * Kiểm tra element có hiển thị không
   */
  isVisible(element) {
    return element.offsetParent;
  }

  /*
   * Lấy control nhập liệu tiếp theo
   */
  getNextInputControl(current) {
    let me = this,
      //i = c.index(),
      p = current.parentNode;
    if (!p) {
      return null;
    }

    let ch = p.children,
      r = null,
      o,
      i = 0;
    for (; i < ch.length; i++) {
      if (ch[i] === current) {
        break;
      }
    }

    for (var k = i + 1; k < ch.length; k++) {
      o = ch[k];
      if (
        ["INPUT", "TEXTARE", "BUTTON", "A"].indexOf(o.tagName) > -1 &&
        !o.getAttribute("disabled") &&
        !o.getAttribute("tabindex") !== -1 &&
        me.isVisible(o)
      ) {
        r = o;
      } else {
        r = me.getFirstControlFocus(o);
      }

      if (r) {
        break;
      }
    }

    if (!r) {
      r = me.getNextInputControl(p);
    }

    return r;
  }
  /**
   * Lấy control nhập liệu đầu tiên
   */
  getFirstControlFocus(parent) {
    const me = this,
      obj = parent || document,
      selector = [
        'input:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"]):not(.ms-con-dropdown)',
        'a:not([disabled]):not([tabindex="-1"]):not(.ms-collapse-item--header)'
      ].join(",");

    const items = obj.querySelectorAll(selector);
    if (items != null && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (me.isVisible(item)) {
          return item;
        }
      }
    }

    return null;
  }

  /**
   * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
   * @param {Element} scope Parent cần tìm input
   */
  findFirstControlInput(scope) {
    if (scope && scope.querySelector) {
      var input = scope.querySelector(
        "input:not([type=button]):not([type=radio]):not([type=checkbox]):not([readonly]):not([disabled]):not([class='hidden']),textarea:not([readonly]):not([disabled]):not([class='hidden'])"
      );
      return input;
    }
    return;
  }

  /**
   * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author DNThang - 31.10.2019
   */
  focusFirstControlInput(scope, select = true) {
    var me = this;

    // setTimeout(() => {
    var input = me.findFirstControlInput(scope);
    if (input) {
      input.focus();

      if (select && typeof input.select === "function") {
        input.select();
      }
    } else {
      //nếu k có input nào để focus thì focus vào dòng đầu tiên của grid( nếu có ) để có thể thực hiện phím tắt keydown up/down để chọn dòng
      me.focusFirstRowGrid(scope);
    }
    // });
  }

  /**
   * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author bnduc - 15.11.2019
   */
  focusFirstControl(scope) {
    if (scope) {
      const me = this;

      // setTimeout(() => {
      let input;
      if (
        scope.type === "text" ||
        (scope.hasAttribute &&
          scope.hasAttribute("type") &&
          scope.getAttribute("type") === "text")
      ) {
        input = scope;
      } else {
        input = me.findFirstControlFocus(scope);
      }

      if (input) {
        input.focus();
      }
      // });
    }
  }

  /**
   * Tự động focus vào control nhập liệu vào dòng đầu tiên của grid( nếu có ) để có thể thực hiện phím tắt keydown up/down để chọn dòng
   * @param {Element} scope Phạm vi cần xử lý focus
   * @author nnlam - 16.06.2021
   */
  focusFirstRowGrid(scope) {
    if (scope) {
      const me = this;

      // setTimeout(() => {
      let grid;
      if (me.grid) {
        grid = me.grid.$el;
      } else {
        grid = me.findFirstGrid(scope);
      }

      if (grid) {
        //me.$nextTick(() => {
        if (grid) {
          let trFirst = grid.querySelector('.ms-tbody.data tr');
          if (trFirst) {
            trFirst.focus();
          }
        }
      }
    }
  }

  /**
   * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
   * @param {Element} scope Parent cần tìm input
   * @author bnduc - 15.11.2019
   */
  findFirstControlFocus(scope) {
    if (scope && scope.querySelector) {
      let input = scope.querySelector(
        "input:not([readonly]):not([disabled]),button:not([disable]),a,textarea"
      );
      return input;
    }
    return;
  }

  /**
   * focus vào control trước đó
   */
  focusPreviewControl(curfocus) {
    const me = this;
    let fn = function (parent) {
      let items = parent.querySelectorAll('input:not([disabled]),button:not([disable]),a');
      if (items[0] !== curfocus) {
        for (let i = 1; i < items.length; i++) {
          if (items[i] === curfocus) {
            for (let j = i - 1; j >= 0; j--) {
              //check item visible
              if (me.isVisible(items[j])) {
                items[j].focus();
                return;
              }
            }
            //reset focus to parent
            curfocus = parent;
          }
        }
      }
      fn(parent.parentElement);
    }

    fn(curfocus.parentElement);
  }

  /**
   * Tìm ra grid đầu tiên của form
   * @param {Element} scope Parent cần tìm grid
   * @author nnlam - 16.06.2021
   */
  findFirstGrid(scope) {
    if (scope && scope.querySelector) {
      let grid = scope.querySelector(".ms-grid-viewer");
      return grid;
    }
    return;
  }

  /**
   * Xử lý khi focus control cuối cùng thì sẽ thực thi fn
   */
  processUnfocusLastControl(e, fn) {
    if (e.which === 9 && !e.shiftKey) {
      //console.log(e.target.attributes.class.value);
      let cur = e.target;
      let els = e.currentTarget.querySelectorAll("*");
      var flag = true;
      for (let i = 0; i < els.length; i++) {
        if (els[i] === cur) {
          flag = false;
          continue;
        }
        if (flag) {
          continue;
        }

        els[i].focus();
        if (els[i] === document.activeElement) {
          e.preventDefault();
          return;
        }
      }

      //focus first control
      e.preventDefault();
      fn();
    }
  }

  /**
   * Kiểm tra 2 đôi tượng có khác nhau không
   */
  checkDiff(newVal, oldVal) {
    let ret = false;
    if (typeof newVal == "object" && typeof oldVal == "object") {
      for (let field in newVal) {
        if (typeof newVal[field] != "object" && newVal[field] != oldVal[field]) {
          ret = true;
          break;
        }
      }
    }
    return ret;
  }
  /**
   * pvduy 28/06/2021
   * lẩy ra danh sách các trường thay đổi và giá trị thay đổi
   * thêm đoạn xử lý trường hợp tìm sự thay đổi cửa giá trị datetime
   */
  getDiffListProperty(newVal, oldVal) {
    let listField = [];
    if (typeof newVal == "object" && typeof oldVal == "object") {
      for (let field in newVal) {
        if (typeof newVal[field] != "object" && newVal[field] != oldVal[field]) {
          listField.push(field);
        }
        else if (newVal[field] instanceof Date) {
          var isChange = false;
          // nếu 2 giá trị khác nhau hoặc một trong 2 thằng null thì xác nhận sự thay đổi.
          if (newVal[field] != null && oldVal[field] != null && typeof (newVal[field].getTime) == "function" && typeof (oldVal[field].getTime) == "function" && newVal[field].getTime() != oldVal[field].getTime()) {
            isChange = true;
          }
          else if ((newVal[field] == null && oldVal[field] != null) || (newVal[field] == null && oldVal[field] != null)) {
            isChange = true;
          }
          if (isChange) {
            listField.push(field);
          }
        }
      }
    }
    return listField;
  }

  //Chuyển dữ liệu thành dạng tree
  // Created by LTDAT(16.06.2020)
  nomalizeDataTree(data, idField, parentField) {
    const me = this;
    let dataTemp = [...data],
      parentNodes = [];
    dataTemp.forEach((item, index) => {
      // if (!item.hasOwnProperty("parentNode")) {
      //   item["parentNode"] = [];
      // }
      if (item[parentField]) {
        //Tìm cha
        let parent = _.find(dataTemp, o => {
          return o[idField] === item[parentField];
        });

        if (parent) {
          // item.parentNode = parent;
          if (!parent.hasOwnProperty("childNodes")) {
            parent["childNodes"] = [];
          }
          if (!parent.hasOwnProperty("isParent")) {
            parent["isParent"] = true;
          }
          parent.childNodes.push(item);
        } else {
          parentNodes.push(item);
        }
      } else {
        // NMSINH: thêm món này vì nếu chọn thằng ko có Cha trong list thì nó chính là cha luôn
        parentNodes.push(item);
      }
    });
    return parentNodes;
  }

  /**
   * Thực hiện ghép các node cha đi kèm với các node con luôn để thực hiện show ra ngay bên dưới node cha
   * @param {[TreeModel]} dataResoures Danh sách các node cha cần sắp xếp
   * @param {*} expanded Có Mở rộng ra không
   * @param {*} level
   */
  getBodyData(dataResoures, expanded, level = 1, childNodes = "childNodes") {
    if (!dataResoures) {
      return [];
    }
    let data = [...dataResoures];
    let bodyData = [];
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      const children = row[childNodes];
      const childrenLen =
        Object.prototype.toString.call(children).slice(8, -1) === "Array"
          ? children.length
          : 0;

      row.level = level;
      Vue.set(row, "isHide", false);
      Vue.set(row, "expanded", expanded);
      // row.expanded = expanded;
      row.isSelected = false;
      row._isSelectedMultiple = false;

      bodyData.push(row);
      if (childrenLen > 0) {
        row._expandable = true;
        bodyData = bodyData.concat(
          this.getBodyData(children, expanded, level + 1)
        );
      }
    }

    return bodyData;
  }

  /**
   * Lấy giá trị enum theo text
   */
  getEnumValue(enumName, text) {
    let source = this.getEnumSource(enumName);
    let textTrim = text.trim();
    for (let i = 0; i < source.length; i++) {
      let item = source[i];
      if (textTrim === item.enumText) {
        return item.enumValue;
      }
    }

    return null;
  }

  /**
   * Lấy ra giá trị key của enum theo value
   * @param {Number} value Giá trị của enum cần lấy ra enum text
   * @param {String} enumName EnumName để get text
   */
  getEnumText(value, enumName) {
    let e = MSEnum[enumName],
      localize = i18n;

    if (e) {
      for (const key in e) {
        if (e.hasOwnProperty(key) && e[key] === value) {
          return key;
        }
      }
    }

    return value;
  }

  /**
   * Lấy ra giá trị key của enum theo value
   * @param {Number} value Giá trị của enum cần lấy ra enum text
   * @param {String} enumName EnumName để get text
   */
  getEnumTextByKey(key, enumName) {
    let e = MSEnum[enumName],
      localize = i18n;

    if (e) {
      for (const f in e) {
        if (e.hasOwnProperty(f)
          && f.toLowerCase() === key.toLowerCase()) {
          return e[f];
        }
      }
    }

    return '';
  }

  /**
   * Lấy ra resource theo enum
   * @param {Number} value Giá trị của enum cần lấy ra enum resource
   * @param {String} enumName EnumName để get text
   */
  getEnumResource(value, enumName) {
    const me = this,
      localize = i18n;

    let key = me.getEnumText(value, enumName);
    let resourceKey = enumName + "." + key;
    let text = localize.t("i18nEnum." + resourceKey);
    return text;
  }

  /**
   * Lấy enumsource với tên enum truyền vào
   * @param {String} enumName Tên enum trong enumeration
   * @param {Array} values Danh sách các enum lấy ra (nếu cần chỉ định), nếu không thì sẽ lấy tất cả
   * @param {Boolean} prefixIdx Có kèm theo tiền tố index không: true - có, false - không (Mặc định không)
   * VD: getEnumSource("EnumCABAReasonType",[10,11,12,13])
   * CreatedBy: PDKIEN 15/08/2019
   */
  getEnumSource(enumName, values, prefixIdx) {
    let e = MSEnum[enumName],
      arr = [],
      localize = i18n;
    if (e) {
      let idx = 0;
      for (const key in e) {
        if (e.hasOwnProperty(key)) {
          let v = e[key],
            ix = -1;
          if (!values || (ix = values.indexOf(v)) > -1) {
            /*
             * sửa lại cách lấy dữ liệu theo enum
             * pvduy 02/02/2020
             */
            let enumText = localize.t("i18nEnum." + enumName + "." + key);
            if (prefixIdx) {
              enumText = ++idx + ". " + enumText;
            }

            let item = {
              enumValue: v,
              enumKey: key,
              enumText: enumText
            };

            if (ix > -1) {
              // DVQUAN: sửa lại cách lấy enum source với trường hợp 9 và 99 => không lấy được 1 trong 2
              if (arr[ix]) {
                arr[arr.length] = item;
              } else {
                arr[ix] = item;
              }
            } else {
              arr.push(item);
            }
          }
        }
      }
    }
    return arr;
  }

  /**
   * Lấy tham số trên query string
   */
  getUrlParams() {
    let search;
    if (window.location.hash) {
      search = window.location.hash.substr(1);
    } else {
      search = window.location.search;
    }
    const temp = new URLSearchParams(search);
    let result = {};
    for (var value of temp.keys()) {
      result[value] = temp.get(value);
    }

    return result;
  }

  /**
   * Đăng xuất khỏi ứng dụng
   */
  logoff() {
    //giải phóng tài nguyên
    let storeDebug = store;
    let fn = [ModuleContext, "logoff"].join("/");
    store.dispatch(fn);
    location.href = '/login';
  }

  downloadLink(link) {
    // location.href = link;
    /*
    let a = document.getElementById("adownload");
    a.href = link;
    a.click();
    */
    this.mask();
    fetch(link,
      {
        method: 'GET', // hoặc 'POST', 'PUT', 'DELETE', v.v.
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${this.getToken()}`
        }
      })
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok");

        // Lấy tên file từ Content-Disposition
        const disposition = response.headers.get('Content-Disposition');
        let fileName = 'downloaded-file';

        if (disposition && disposition.includes('filename=')) {
          const matches = disposition.match(/filename="?([^"]+)"?/);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }

        return response.blob().then(blob => ({ blob, fileName }));
      })
      .then(({ blob, fileName }) => {
        const urlBlob = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = urlBlob;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(urlBlob);
      })
      .catch(error => {
        console.error('Download error:', error);
      })
      .finally(() => {
        this.unmask();
      });
  }

  /**
   * Gán cookie
   */
  setCookie(name, value, hours) {
    var expires = "";
    if (hours) {
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  /**
   * Đọc cookie
   */
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Xóa cookie
   */
  removeCookie(name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  /**
   * Xử lý dữ liệu trả về từ server
   */
  processServerResponseData(data) {
    if (data) {
      const rgDate = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d/;
      const rgDateTime = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(.)?(\d{0,9})?(Z)?(\+)?(\d{2})?(:)?(\d{2})?$/;
      for (let i in data) {
        if (data[i]) {
          let dataValue = data[i];
          if (
            typeof dataValue === "string"
            // i.indexOf("Date") > -1 &&
            && (rgDate.test(dataValue) || rgDateTime.test(dataValue))
          ) {
            let dateValue = new Date(dataValue);
            if (!isNaN(dateValue.getTime())) {
              data[i] = dateValue;
            }
          } else if (
            typeof dataValue === "object" &&
            Object.keys(dataValue.length > 0)
          ) {
            this.processServerResponseData(dataValue);
          }
        }
      }
    }
  }

  /**
   * Lấy text hiển thị của trường thông tin
   * @param {*} field : Tên trường
   * @param {*} namespace : mã để xem có custom lại không, nếu không thì lấy mặc định
   */
  getColumnText(field, namespace) {
    const localize = i18n;
    const common = localize.messages[localize.locale]["i18nColumn"];
    const custom = namespace ? common[namespace] : null;

    if (custom && custom.hasOwnProperty(field)) {
      return custom[field];
    }
    return common[field];
  }

  /**
   * Lấy text hiển thị của bảng
   * @param {*} table : Tên bảng
   * @param {*} namespace : mã để xem có custom lại không, nếu không thì lấy mặc định
   */
  getTableText(table, namespace) {
    const localize = i18n,
      common = localize.messages[localize.locale]["i18nTable"],
      custom = namespace ? common[namespace] : null;

    if (custom && custom.hasOwnProperty(table)) {
      return custom[table];
    }
    return common[table];
  }
  /**
   * Maping từ html element thành đối tượng vuejs để thao tác
   * @param {object} dom html dome element
   */
  mapDomToVue(dom) {
    return dom.__vue__;
  }

  /**
   * Chuyển tiếng việt có dấu thành không dấu
   * @author ĐVThi 09/03/2021
   */
  removeVietnameseTones(str) {
    if (str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      //str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
      return str;
    } else {
      return "";
    }
  }

  buildFilterParam(filters) {
    let me = this,
      sFilter = "";

    if (filters && !(filters instanceof Array)) {
      filters = [filters];
    }

    let length = filters.length;

    if (length > 0) {
      //Clear múi giờ trước khi đẩy lên server
      filters.forEach((item, i) => {
        let value = item.value;
        if (value) {
          if (typeof value.getFullYear === 'function') {
            item.value = moment(value).format('YYYY-MM-DDTHH:mm:ss');
          }
        }
      });

      sFilter = JSON.stringify(filters);
    }

    return sFilter;
  }

  /**
   * Xử lý tham số trước khi gọi lên server load dữ liệu cho combobox
   */
  processComboboxParamRequest(param) {
    const me = this;
    for (let i in param) {
      let value = param[i];
      switch (i) {
        case "filter":
          //chuẩn hóa tham số filter
          if (Array.isArray(value) && value.length > 0) {
            value = me.buildFilterParam(value);
          } else {
            continue;
          }
          break;
      }
      param[i] = value;
    }
  }

  setLocalStorage(key, value) {
    localStorage.setItem(this.processLocalStorageKey(key), value);
  }

  getLocalStorage(key) {
    return localStorage.getItem(this.processLocalStorageKey(key));
  }

  removeLocalStorage(key) {
    localStorage.removeItem(this.processLocalStorageKey(key));
  }

  processLocalStorageKey(key) {
    return [window._appConfig.localStoragePrefix, key].join('');
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  checkFullMonth(fromDate, toDate) {
    let shortText = "",
      localize = i18n;
    if (fromDate && toDate) {
      if (fromDate.getDate() == 1) {
        let fromYear = fromDate.getFullYear(),
          fromMonth = fromDate.getMonth();
        let toYear = toDate.getFullYear(),
          toMonth = toDate.getMonth();
        let daysOfMonth = 32 - new Date(toYear, toMonth, 32).getDate();
        if (toDate && daysOfMonth == toDate.getDate()) {
          if (fromMonth == toMonth && fromYear == toYear) {
            shortText = localize
              .t("i18nReport.ReportTerm")
              .format(fromMonth + 1, fromYear);
          } else if (fromMonth < toMonth && fromYear == toYear) {
            shortText = localize
              .t("i18nReport.ReportTermRange")
              .format(fromMonth + 1, toMonth + 1, fromYear);
          }
          return shortText;
        }
      }
    }
    return shortText;
  }

  helpAms(helpId) {
    return null;
  }

  /**
   * Func bỏ dấu tiếng việt
   * @param {String} str
   * @author NCThanh1
   */
  removeUnicode(str) {
    let tmp = str;
    tmp = tmp.toLowerCase();
    tmp = tmp.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    tmp = tmp.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    tmp = tmp.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    tmp = tmp.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    tmp = tmp.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    tmp = tmp.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    tmp = tmp.replace(/đ/g, "d");
    tmp = tmp.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    tmp = tmp.replace(/ + /g, " ");
    tmp = tmp.trim();
    return tmp;
  }

  /**
   * Load dữ liệu combobox
   */
  getCacheComboboxData(type, payload, loadPromise, loadScope) {
    let key = [type, JSON.stringify(payload)].join('_').toLowerCase(),
      cache = window._cboData[key];

    return new Promise(resolve => {
      if (cache) {
        resolve(cache);
        return;
      }

      loadPromise.call(loadScope, payload)
        .then(result => {
          window._cboData[key] = result;
          resolve(result);
        });
    });
  }

  /**
   * Load dữ liệu combobox
   */
  removeCacheComboboxData(key) {
    const caches = window._cboData;
    if (caches) {
      var keys = [];
      if (Array.isArray(key)) {
        keys = key;
      } else if (typeof (key) === 'string') {
        keys.push(key);
      } else {
        keys.push(String(key));
      }

      keys.forEach(item => {
        let key = [item, ''].join('_').toLowerCase(),
          removeKeys = [];
        for (let i in caches) {
          if (i.indexOf(key) === 0) {
            removeKeys.push(i);
          }
        }

        for (let i = 0; i < removeKeys.length; i++) {
          let cacheKey = removeKeys[i];
          delete caches[cacheKey];
        }
      });
    }
  }

  /**
  * Tách từ khóa tìm kiếm thành các từ theo quy tắc
  * 1. Nếu có ngoặc kép "" thì tìm đúng kí tự trong ngoặc kép
  * 2. Nếu không thì chỉ cần chứa cả 2 kí tự là đủ
  * @param {string} keyword từ khóa tìm kiếm
  * @author NVLAM 23.11.2020
  */
  splitKeyWord(keyword) {
    let wordArr = [];
    if (typeof (keyword) !== 'string') {
      keyword = _.toString(keyword);
    }
    let firstDoubleQuoteIdx = keyword.indexOf('"'),
      lastDoubleQuoteIdx = keyword.lastIndexOf('"');
    /**
     * Các TH tìm kiếm full text
     * 1. Đây là foo
     * 2. "Đây là foo
     * 3. Đây "là foo"
     * 4. "Đây là" foo
     */
    if (firstDoubleQuoteIdx === -1 || firstDoubleQuoteIdx === lastDoubleQuoteIdx || firstDoubleQuoteIdx !== 0 || lastDoubleQuoteIdx !== keyword.length - 1) {
      wordArr = keyword.split(/\s+/);//tách theo dấu cách
    } else {
      let fullText = keyword.slice(firstDoubleQuoteIdx + 1, lastDoubleQuoteIdx);
      if (!_.isEmpty(fullText)) {
        wordArr.push(fullText);
      }
    }
    // for (let i = 0; i < wordArr.length; ++i) {
    //     wordArr[i] = wordArr[i].replace(/[^a-z\d]/g, '\\$&');//chèn thêm 1 kí từ
    // }
    return wordArr;
  }

  /**
   * hàm search local
   * properties: danh sách các trường cần search
   * searchText: text nhập ở ô search
   * source: dữ liệu gốc dùng để filter
   * grid: grid filter
   */
  filterFn(properties, source, grid, searchText, form) {
    let data = [], me = this;
    let sourceTemp = [];
    if (Array.isArray(source)) {
      Object.assign(sourceTemp, source)
      if (searchText && searchText != '') {
        sourceTemp.forEach(item => {
          if (me.checkSearchText(item, properties, searchText) && me.checkFilterHeader(item, grid) && form.checkFilterGridTreeCustom(item, properties, searchText)) {
            if (data.indexOf(item) === -1) {
              data.push(item);
            }
            if (grid && grid.isGridTree) {
              me.findParentNode(source, data, item, form);
            }
          }
        })
      } else {
        data = sourceTemp;
      }
    }
    if (form.filterHeader && form.filterHeader.length > 0) {
      grid.dataTemp = data;
    } else {
      grid.dataTemp = source;
    }
    return data;
  }

  /*
  *  Hàm tìm kiếm các node cha khi thực hiện tìm kiếm dữ liệu. 
  *  pvduy 06/01/2021
  */
  findParentNode(items, filterItems, itemChild, form) {
    let me = this;
    let key = "",
      parentKey = 'ParentID';
    if (form && form.grid && form.grid.idProperty) {
      key = form.grid.idProperty;
    }
    if (form && form.grid && form.grid.parentIdProperty) {
      parentKey = form.grid.parentIdProperty;
    }
    items.forEach(item => {
      if (item[key] == itemChild[parentKey] && !filterItems.find(x => x[key] == item[key])) {
        if (filterItems.indexOf(item) === -1) {
          filterItems.push(item);
        }
        me.findParentNode(items, filterItems, item, form);
      }
    });
  }
  /**
   * hàm filter col
   */
  checkFilterHeader(item, grid) {
    let me = this;
    let listFilterHeader = [], check = true;
    listFilterHeader = grid.getFilterHeader(true);
    if (listFilterHeader.length > 0) {
      listFilterHeader.forEach(filter => {
        let value = filter.value ? (filter.value + '').toLowerCase() : '';
        switch (filter.operator) {
          case MSEnum.FilterHeader.Contains:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : "").contains(value)) {
              check = false;
              return false;
            }
            break;
          case MSEnum.FilterHeader.Notcontains:
            if ((item[filter.property] ? item[filter.property].toLowerCase() : "").contains(value)) {
              check = false;
              return false
            }
            break;
          case MSEnum.FilterHeader.StartsWith:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : "").startsWith(value)) {
              return false
            }
            break;
          case MSEnum.FilterHeader.EndsWith:
            if (!(item[filter.property] ? item[filter.property].toLowerCase() : "").endswith(value)) {
              check = false;
              return false
            }
            break;
          case MSEnum.FilterHeader.Equals:
            if (item[filter.property] != filter.value) {
              check = false;
              return false
            }
            break;
          case MSEnum.FilterHeader.NotEquals:
            if (item[filter.property] == filter.value) {
              check = false;
              return false
            }
            break;
          case MSEnum.FilterHeader.GreaterThan:
            if (item[filter.property] <= filter.value) {
              check = false;
              return false;
            }
            break;
          // case MSEnum.FilterHeader.GreaterThan:
          //   if(item[filter.property] < filter.value){
          //     check = false;
          //     return false;
          //   }
          //   break;
          case MSEnum.FilterHeader.LessThan:
            if (item[filter.property] >= filter.value) {
              check = false;
              return false;
            }
            break;
          case MSEnum.FilterHeader.LessThanEquals:
            if (item[filter.property] > filter.value) {
              check = false;
              return false
            }
            break;
          case MSEnum.FilterHeader.Between:
            //if(item[filter.property] > filter.value){
            check = false;
            return false;
            //}
            break;
          case MSEnum.FilterHeader.Null:
            if (item[filter.property]) {
              check = false;
              return false
            }
            break;
          case MSEnum.FilterHeader.NotNull:
            if (!item[filter.property]) {
              check = false;
              return false
            }
            break;

        }
      })
    }
    return check;
  }
  /**
   * hàm search theo text
   */
  checkSearchText(item, properties, searchText) {
    let me = this, check = false;
    if (searchText) {
      let text = searchText.toLowerCase();
      if (Array.isArray(properties)) {
        properties.forEach(field => {
          if (item[field] && item[field].toLowerCase().contains(text)) {
            check = true;
            return;
          }
        })
      }
    } else {
      return true;
    }
    return check;
  }

  /**
   * Lấy thông tin phiên đăng nhập
   */
  getContext() {
    const windowKey = "_context";
    let context = window[windowKey];
    if (!context) {
      context = this.getLocalStorage('Context');
      if (context) {
        window[windowKey] = context = JSON.parse(context);
      }
    }

    return context;
  }

  /**
   * Lấy token
   */
  getToken() {
    return this.getLocalStorage('Token');
  }

  /**
   * Lấy token
   */
  getUserId() {
    return this.getLocalStorage('UserId');
  }

  /**
   * xử lý string trước khi render để chống xss
   */
  processXssValue(value) {
    if (typeof value === 'string') {
      // return value.replace(/</g, '&lt');
      return _.escape(value);
    }

    return value;
  }

  /**
   * Xử lý nội dung dữ liệu trước khi binding để tránh tấn công xss
   */
  processXss(item) {
    const me = this;
    let fn = function (obj, lv) {
      lv = lv || 0;
      for (let i in obj) {
        let v = obj[i];
        if (v) {
          if (typeof v === 'string') {
            obj[i] = me.processXssValue(v);
          } else if (typeof v == 'object' && lv < 10 && Object.keys(v).length > 0) {
            fn(v, lv + 1);
          }
        }
      }
    }
    if (Array.isArray(item)) {
      item.forEach(n => {
        fn(n);
      });
    } else if (typeof item === 'object') {
      fn(item);
    }
  }

  getProfileOption(data, fs) {
    var options = {};
    for (var i in data) {
      if (fs.indexOf(i) === -1 && data[i] != null) {
        options[i] = data[i];
      }
    }
    return options;
  }

  loadProxyCombo() {
    var me = this;
    me.proxyComboboxSource = [];
    proxyApi.getCombo()
      .then(res => {
        if (!res || !Array.isArray(res)) {
          return;
        }

        res.forEach(item => {
          me.proxyComboboxSource.push({
            // text: `http://${item.name}:${item.config}`,
            // value: `http://${item.name}:${item.config}`
            text: item.name,
            value: `http://${item.config}`
          });
        })
      })
      .catch(ex => {
        console.error(ex);
      })
  }

  checkAlphaNumeric(str) {
    return /^[a-zA-Z0-9]+$/.test(str);
  }

  checkAlpha(str) {
    return /^[a-zA-Z]+$/.test(str);
  }

  checkNumeric(str) {
    return /^[0-9]+$/.test(str);
  }

  checkIPv4(ip) {
    if (typeof ip !== 'string') return false;

    const regex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
    return regex.test(ip);
  }

  checkIPv6(value) {
    if (typeof value !== 'string') return false;
    value = value.trim();

    // IPv6 phải chứa dấu :
    if (!value.includes(':')) return false;

    // IPv4 thì không phải IPv6
    if (value.includes('.')) return false;

    const parts = value.split('::');

    // Chỉ được phép có tối đa một ::
    if (parts.length > 2) return false;

    const left = parts[0] ? parts[0].split(':') : [];
    const right = parts[1] ? parts[1].split(':') : [];

    // Mỗi group phải từ 1-4 ký tự hex
    const isValidPart = part =>
      /^[0-9a-fA-F]{1,4}$/.test(part);

    if (!left.every(isValidPart) || !right.every(isValidPart)) {
      return false;
    }

    // Không có :: thì phải đúng 8 group
    if (parts.length === 1) {
      return left.length === 8;
    }

    // Có :: thì tổng group phải < 8
    return left.length + right.length < 8;
  }

  checkCidr(text) {
    const cidrRegex = /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\/([0-9]|[1-2][0-9]|3[0-2])$/;
    return cidrRegex.test(text);
  }

  getSearchLink(text, target) {
    let isIp = this.checkIPv4(text) || this.checkIPv6(text);
    if (isIp) {
      return '/search/host';
    }

    let lowerText = text.toLowerCase();
    if (lowerText.indexOf('cve-') === 0
      && lowerText.indexOf('.') === -1) {
      return "/search/cve";
    }

    let isDomain = this.checkDomain(text);
    if (isDomain) {
      return '/search/domain';
    }

    return "/search/query";

    // if (text.indexOf(':') > -1 || this.checkCidr(target)) {
    //   return "/search/query";
    // }

    // return '/search/domain';
  }

  checkDomain(input) {
    const domainRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    return domainRegex.test(input);;
  }

  getDomain(input) {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.hostname;
    } catch (error) {
      return null; // hoặc thông báo lỗi tùy ý
    }
  }

  viewIpDomainDetail(target) {
    var text = (target || '').trim();
    if (text.length === 0) {
      // me.$toast.error(`Ip không hợp lệ: ${ip}`);
      return;
    }

    // let isCidr = this.checkCidr(target);
    // if (isCidr) {
    //   return;
    // }

    let ds = text.split('://');
    text = ds[ds.length - 1];
    ds = text.split(':');
    if (ds.length == 2 && this.checkIPv4(ds[0]) && /^-?\d+(\.\d+)?$/.test(ds[1])) {
      text = ds[0];
    }

    let newLink = this.getSearchLink(text, target);
    let curLink = location.pathname.toLowerCase();

    // let ds2 = text.split('/');
    // text = ds2[0];

    if (curLink.indexOf(newLink) > -1 && typeof window.__navsearch === 'function') {
      window.__navsearch(text);
    } else {
      router.push({
        path: newLink,
        query: {
          query: text
        }
      });
    }

    document.querySelector('.nav-search input').value = text;
  }

  handle401() {
    const me = this;
    if (me._show401) {
      return;
    }
    me._show401 = true;
    messageBox
      .showError('Phiên làm việc đã kết thúc.')
      .then(() => {
        me.logoff();
      });
  }

  initLeaflet(L) {
    // 👇 Fix đường dẫn icon mặc định
    delete L.Icon.Default.prototype._getIconUrl

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href,
      iconUrl: new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href,
      shadowUrl: new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).href
    })
  }

  getCountryData() {
    let country = [];
    countryNameJson.forEach(n => {
      country.push({
        country: n,
      });
    });
    return country;
  }

  mapCountryByFeature(feature, countryData) {
    const countryName = feature.properties.ADMIN || feature.properties.name;
    // const originalName = (nameMap[countryName.toLowerCase()] || countryName).toLowerCase();
    const originalName = this.mapCountryName(countryName).toLowerCase();
    const data = countryData.find(x => x.country.toLowerCase() === originalName);
    return data;
    // return this.mapCountryByName(feature.properties.ADMIN || feature.properties.name, countryData);
  }

  mapCountryName(countryName) {
    if (!countryName) {
      return '';
    }

    const nameMap = {
      "united states of america": "United States",
      "us": "United States",
      "korea, south": "South Korea",
      "korea, north": "North Korea",
      "russian federation": "Russia",
      "syrian arab republic": "Syria",
      "czechia": "Czech Republic",
      "democratic republic of the congo": "DR Congo",
      "republic of the congo": "Republic Of Congo",
      "côte d'ivoire": "Ivory Coast",
      "lao people's democratic republic": "Laos",
      "myanmar": "Myanmar (Burma)",
      "viet nam": "Vietnam",
      "vn": "Vietnam",
      "cabo verde": "Cape Verde",
      "timor-leste": "East Timor",
      "eswatini": "Wwaziland",
      "st-martin": "Saint Martin",
      "dominican rep.": "Dominican Republic",
      "curaçao": "Curacao",
      "turks and caicos is.": "Turks and Caicos Islands",
      "st. pierre and miquelon": "Saint Pierre and Miquelon",
      "st. vin. and gren.": "Saint Vincent and the Grenadines",
      "antigua and barb.": "Antigua and Barbuda",
      "st. kitts and nevis": "Saint Kitts and Nevis",
      "u.s. virgin is.": "U.S. Virgin Islands",
      "st-barthélemy": "Saint Barthelemy",
      "british virgin is.": "British Virgin Islands",
      "cayman is.": "Cayman Islands",
      "n. cyprus": "Cyprus",
      "siachen glacier": "",  //TODO
      "indian ocean ter.": "British Indian Ocean Territory",
      "falkland is.": "Falkland Islands",
      "s. sudan": "Sudan",
      "somaliland": "Somalia",
      "w. sahara": "Western Sahara",
      "congo": "Republic Of Congo",
      "dem. rep. congo": "Democratic Republic of the Congo",
      "central african rep.": "Central African Republic",
      "eswatini": "Eswatini",
      "eq. guinea": "Equatorial Guinea",
      "são tomé and principe": "Sao Tome and Principe",
      "bosnia and herz.": "Bosnia and Herzegovina",
      "vatican": "Vatican City",
      "åland": "Aland",
      "faeroe is.": "Faroe Islands",
      "pitcairn is.": "Pitcairn Islands",
      "fr. polynesia": "French Polynesia",
      "marshall is.": "Marshall Islands",
      "cook is.": "Cook Islands",
      "wallis and futuna is.": "Wallis and Futuna",
      "solomon is.": "Solomon Islands",
      "n. mariana is.": "Northern Mariana Islands",
      "ashmore and cartier is.": "",  //TODO
      "fr. s. antarctic lands": "Antarctica",
      "heard i. and mcdonald is.": "Heard Island and McDonald Islands",
      "br. indian ocean ter.": "British Indian Ocean Territory",
      "s. geo. and the is.": "South Georgia and the South Sandwich Islands",
      'australia': 'Austria',
      'au': 'Austria',
    };

    return nameMap[countryName.toLowerCase()] || countryName;
  }

  getTimeDiffText(start, end) {
    const startTime = new Date(start);
    const endTime = new Date(end);

    const diffMs = endTime - startTime;
    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    if (diffMinutes <= 1) {
      return '1 phút trước';
    } else if (diffMinutes <= 60) {
      return `${diffMinutes} phút trước`;
    } else {
      return `${diffMinutes} phút trước`; // hoặc xử lý thêm nếu muốn hiện giờ, ngày, v.v.
    }
  }

  random(min, max) {
    return Math.floor(Math.random() * max) + min;
  }

  calTotalScore(record) {
    let cvss = this.getCvss(record.metrics);
    let isRemote = JSON.stringify(record).toLowerCase().indexOf('remote') > -1;
    let exploitability = Math.min(10, Math.roundNumber(isRemote ? 10 : cvss * 0.8, 1));
    let epss = this.getEpss(record);
    let popularity = Math.min(10, Math.roundNumber((epss > 0 ? epss : 0.0018) * 1.5 * 1000, 1));

    let value = Math.roundNumber(cvss + exploitability + popularity, 1);
    // console.log(record.cve_id, value, cvss, exploitability, popularity);
    // return value;
    return {
      value,
      cvss,
      exploitability,
      popularity
    }
  }

  getEpss(record) {
    if (record.metrics
      && record.metrics.epss
      && record.metrics.epss.data
      && record.metrics.epss.data.score > 0) {
      return record.metrics.epss.data.score;
    }

    return 0;
  }

  getCvss(metrics) {
    if (metrics) {
      let value = this.getCvssItem(metrics.cvssV4_0)
        || this.getCvssItem(metrics.cvssV3_1)
        || this.getCvssItem(metrics.cvssV3_0)
        || this.getCvssItem(metrics.cvssV2_0)
        || 0;
      return value;
    }
    return 0;
  }

  getCvssItem(item) {
    if (item
      && item.data
      && item.data.score > 0) {
      return item.data.score;
    }

    return 0;
  }

  getCvssLevel(value) {
    if (value >= 9) {
      return 'critical'
    }

    if (value >= 7) {
      return 'high'
    }

    if (value > 4) {
      return 'medium'
    }

    if (value > 0.1) {
      return 'low'
    }

    return 'info';
  }

  getCvssItem(item) {
    if (item
      && item.data
      && item.data.score > 0) {
      return item.data.score;
    }

    return 0;
  }

  getCvss(metrics) {
    if (metrics) {
      let value = this.getCvssItem(metrics.cvssV4_0)
        || this.getCvssItem(metrics.cvssV3_1)
        || this.getCvssItem(metrics.cvssV3_0)
        || this.getCvssItem(metrics.cvssV2_0)
        || 0;
      return value;
    }
    return 0;
  }

  getRisk(value) {
    if (value >= 9) {
      return 4
    }

    if (value >= 7) {
      return 3
    }

    if (value > 4) {
      return 2
    }

    if (value > 0.1) {
      return 1
    }

    return 0;
  }

  getUserTemplateDir() {
    let userId = this.getLocalStorage('UserId'),
      userDir = `customize/user/${userId}`.toLowerCase();
    return userDir;
  }

  formatName(value) {
    let vs = (value || '').trim();
    if (!vs) {
      return value;
    }

    let ds = vs.split(' ');
    for (let i = 0; i < ds.length; i++) {
      let v = ds[i];
      if (!v || v.length < 1) {
        continue;
      }
      ds[i] = `${v[0].toUpperCase()}${v.substr(1)}`;
    }

    return ds.join(' ');
  }

  processScanValue(value) {
    if (!value) {
      return null;
    }

    if (typeof value !== 'string') {
      return value;
    }

    if (['unknown', 'na', 'n/a'].indexOf(value.toLowerCase()) > -1) {
      return null;
    }

    let rms = [
      { f: '\u001b', v: '' },
      { f: '\u001B', v: '' },
      { f: '[0m', v: '' },
      { f: '[1m', v: '' },
      { f: '1m', v: '' },
      { f: 'server', v: 'Server' },
      { f: 'http', v: 'Http' },
      { f: 'header', v: 'Header' },
    ];
    rms.forEach(n => {
      value = value.replaceAll(n.f, n.v);
    });

    if (!value) {
      return null;
    }

    return this.formatName(value);
  }

  getEngineSource(level) {
    let rs = [];
    let ignores = [];
    try {
      ignores = window._appConfig.deviceScan.ignoreComboboxEngines || [];
    } catch (ex) {
      console.error(ex);
    }

    (window._engines || []).forEach(x => {
      if (x.level == level) {
        if (ignores.indexOf(x.code) == -1) {
          rs.push(x);
        }
      }
    })
    return rs;
  }

  openNewTab(link) {
    let a = document.getElementById("adownload");
    a.href = link;
    a.click();
  }

  findEngine(id) {
    let engines = window._engines || [];
    for (let i = 0; i < engines.length; i++) {
      let item = engines[i];
      if (item.id == id) {
        return item;
      }
    }

    return null;
  }

  renderMarkdown(text) {
    if (!text) {
      return "";
    }

    try {
      // Không cho phép raw HTML trong Markdown.
      const markdownHtml = marked.parse(text, {
        html: false,
        breaks: true
      });

      /**
       * Defense-in-depth:
       * Sau khi marked convert Markdown -> HTML,
       * tiếp tục sanitize trước khi đưa vào v-html.
       */
      return DOMPurify.sanitize(markdownHtml, {
        ALLOWED_TAGS: [
          "p",
          "br",
          "strong",
          "b",
          "em",
          "i",
          "u",
          "del",
          "s",
          "blockquote",

          "ul",
          "ol",
          "li",

          "code",
          "pre",

          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",

          "hr",

          "a",

          "table",
          "thead",
          "tbody",
          "tfoot",
          "tr",
          "th",
          "td"
        ],

        ALLOWED_ATTR: [
          "href",
          "title",
          "target",
          "rel"
        ],

        ALLOW_DATA_ATTR: false,

        /**
         * Chỉ cho phép URL an toàn.
         * javascript:, vbscript:, data: sẽ bị loại bỏ.
         */
        ALLOWED_URI_REGEXP:
          /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,

        /**
         * Defense-in-depth cho event handler.
         */
        FORBID_ATTR: [
          "style",
          "onclick",
          "onerror",
          "onload",
          "onmouseover",
          "onfocus",
          "onmouseenter",
          "onmouseleave"
        ],

        FORBID_TAGS: [
          "script",
          "iframe",
          "object",
          "embed",
          "form",
          "input",
          "button",
          "textarea",
          "select",
          "option",
          "svg",
          "math"
        ]
      });
    } catch (error) {
      console.error("Markdown render error:", error);

      return "";
    }
  }
}
export default new CommonFunction();
